import {
    createCartBillingFormData,
    getPaypalOrderId
} from '../api';
import {
    addProductForPDPbtnFlow,
    appendToUrl
} from './pdpHelper';
import {
    getPaypalButtonStyle
} from '../helper';

var loaderInstance = require('../loader');
var $loaderContainer = document.querySelector('.paypalLoader');
var loader = loaderInstance($loaderContainer);
var pid;
var uuid;
var removeFromCartUrl;
var usedPaymentMethod;

/**
 * Saves used payment method to variable
 *
 * @param {Object} data - object with data
 */
function onClick(data) {
    if (data.fundingSource === 'venmo') {
        usedPaymentMethod = 'Venmo';
    }
}

/**
 * Creates order and returns an order id
 * @returns {string} an order id
 */
function createOrder() {
    const res = addProductForPDPbtnFlow();

    if (res.cart) {
        uuid = res.pliUUID;
        removeFromCartUrl = res.cart.actionUrls.removeProductLineItemUrl;
        pid = res.pid;
    } else {
        loader.hide();

        throw new Error(res.message || 'Error occurs');
    }

    return getPaypalOrderId();
}

/**
 *  Makes post call to returnFromCart endpoint, goes to checkout place order stage
 *
 */
function onApprove() {
    loader.show();

    let cartBillingFormData = createCartBillingFormData({
        usedPaymentMethod: usedPaymentMethod
    }, document.querySelector('.js_paypal_button_on_pdp_page'));

    $.ajax({
        type: 'POST',
        url: window.paypalUrls.returnFromCart,
        contentType: false,
        data: cartBillingFormData,
        processData: false,
        success: () => {
            loader.hide();
            window.location.href = window.paypalUrls.placeOrderStage;
        },
        error: function () {
            loader.hide();
            window.location.href = window.paypalUrls.cartPage;
        }
    });
}

/**
 * Hides loader on paypal widget closing without errors
 * If PDP flow, removes product from basket on cancel
 */
function onCancel() {
    var urlParams = {
        pid: pid,
        uuid: uuid
    };

    $.ajax({
        url: appendToUrl(removeFromCartUrl, urlParams),
        type: 'get',
        dataType: 'json',
        success: function () {
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
    loader.hide();
}

/**
 * Shows errors if paypal widget was closed with errors
 * If PDP flow, removes product from basket on error
 */
function onError() {
    if (pid) {
        var productID = pid;
        var urlParams = {
            pid: productID,
            uuid: uuid
        };

        $.ajax({
            url: appendToUrl(removeFromCartUrl, urlParams),
            type: 'get',
            dataType: 'json',
            success: function () {
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
    loader.hide();
    window.location.href = window.paypalUrls.cartPage;
}

/**
 *Inits paypal button on cart page
 */
function initPaypalButton() {
    loader.show();
    window.paypal.Buttons({
        onClick,
        createOrder,
        onApprove,
        onCancel,
        onError,
        style: getPaypalButtonStyle(document.querySelector('.js_paypal_button_on_pdp_page'))
    }).render('.paypal-pdp-button')
        .then(() => {
            loader.hide();
        });
}

export default initPaypalButton;
